import { parseContextReferences } from '@runloop/reflex-contract';
import { parseGitHubPrUrl, parsePrExternalId, type GitHubPrRef } from '@reflex/shared';

/** The context reference kind `plugin-github` registers for pull requests. */
const GITHUB_PR_KIND = 'github-pr';

/**
 * The first pull request a launch prompt names, however it was written.
 *
 * A PR reaches the prompt two ways now: typed or dropped in as a raw URL, or
 * pasted — in which case the composer has already turned it into a
 * `@[owner/repo#42](github-pr:owner/repo#42)` chip and there is no URL left in
 * the text to match. Both are the same intent ("work on this PR"), so both
 * pre-fill the git-repo attachment.
 */
export function promptPullRequest(prompt: string): GitHubPrRef | null {
  for (const reference of parseContextReferences(prompt)) {
    if (reference.kind !== GITHUB_PR_KIND) continue;
    const parsed = parsePrExternalId(reference.id);
    if (!parsed) continue;
    const [owner, repo] = parsed.repoSlug.split('/');
    return { owner, repo, number: parsed.number };
  }
  return parseGitHubPrUrl(prompt);
}
